import { render, staticRenderFns } from "./PieChartComponent.vue?vue&type=template&id=2e722420&scoped=true"
import script from "./PieChartComponent.vue?vue&type=script&lang=ts"
export * from "./PieChartComponent.vue?vue&type=script&lang=ts"
import style0 from "./PieChartComponent.vue?vue&type=style&index=0&id=2e722420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e722420",
  null
  
)

export default component.exports